import { useEffect, useState } from "react";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

export interface IProps {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  uri?: string;
}

const usePDF = (props: IProps) => {
  const { setLoading } = props;
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  useEffect(() => {
    setLoading(false);
  }, []);
  return {
    ...props,
    defaultLayoutPluginInstance,
  };
};

export type Props = ReturnType<typeof usePDF>;

export default usePDF;
